import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { inputBaseStyles, requiredAsteriskStyles } from '../../styles/inputStyles';
import { formatDateForApi } from '../../utils/date';
interface DatePickerFieldProps {
  label?: string;
  value: Dayjs | null;
  onChange: (date: string | null) => void;
  width?: string;
  optional?: boolean;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
}

const StyledDatePicker = styled(DatePicker)(() => ({
  ...inputBaseStyles,
  ...requiredAsteriskStyles
}));

const HelperText = styled(Typography)({
  marginTop: '6px',
  fontSize: '14px',
  color: '#667085',
});

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  label,
  value,
  onChange,
  width = '100%',
  optional = false,
  required = false,
  helperText,
  placeholder,
}) => {
  return (
    <Box sx={{ width }}>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography component="label" className="input-field-label">
            {label}
            {required && <span>*</span>}
          </Typography>
        </Box>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StyledDatePicker
          value={value}
          onChange={(date) => onChange(formatDateForApi(date))}
          slots={{
            openPickerIcon: CalendarTodayIcon,
          }}
          slotProps={{
            textField: {
              placeholder: placeholder || '',
              fullWidth: true,
            },
          }}
        />
      </LocalizationProvider>
      {helperText && <HelperText>{helperText}</HelperText>}
    </Box>
  );
};

export default DatePickerField; 